export default __webpack_public_path__ + "static/media/activity-outline.2aa18602.svg";